import { Button, Icon } from 'antd'

const ExportButton = ({ onClick, label, isLoading, isDisable, iconType }) => {
  return (
    <Button onClick={() => onClick()} disabled={isDisable} loading={isLoading} className="p-button-export">
      <Icon type={iconType == 'csv' ? 'file' : 'file-excel'} style={{ fontSize: '14px' }} />
      {label}
    </Button>
  )
}

export default ExportButton
